import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../../context/ThemeContext';
import { Twitter, Linkedin, Github, Mail, MapPin, Phone } from 'lucide-react';

import BrandLogo from '../common/BrandLogo';
const PublicFooter = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <footer style={{ 
      background: 'var(--bg-secondary)', 
      color: 'var(--text-secondary)',
      borderTop: '1px solid var(--border-color)',
      padding: '5rem 5% 2rem',
      fontSize: '0.9rem',
      lineHeight: '1.6'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '3rem', marginBottom: '4rem' }}>
        
        {/* Brand Column */}
        <div style={{ gridColumn: 'span 2' }}>
          <BrandLogo />
          <p style={{ marginBottom: '1.5rem', maxWidth: '300px' }}>
            A premier digital asset management firm providing institutional-grade algorithmic yields, uncompromised security, and global market exposure.
          </p>
          <div style={{ display: 'flex', gap: '1rem' }}>
            <a href="#" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s' }} onMouseOver={(e)=>e.target.style.color='var(--accent-primary)'} onMouseOut={(e)=>e.target.style.color='var(--text-secondary)'}><Twitter size={20} /></a>
            <a href="#" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s' }} onMouseOver={(e)=>e.target.style.color='var(--accent-primary)'} onMouseOut={(e)=>e.target.style.color='var(--text-secondary)'}><Linkedin size={20} /></a>
            <a href="#" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s' }} onMouseOver={(e)=>e.target.style.color='var(--accent-primary)'} onMouseOut={(e)=>e.target.style.color='var(--text-secondary)'}><Github size={20} /></a>
          </div>
        </div>

        {/* Links Columns */}
        <div>
          <h4 style={{ color: 'var(--text-primary)', fontWeight: '700', marginBottom: '1.5rem', fontSize: '1rem' }}>Solutions</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <li><Link to="/solutions/forex" style={{ color: 'inherit', textDecoration: 'none' }}>Forex Trading</Link></li>
            <li><Link to="/solutions/digital-assets" style={{ color: 'inherit', textDecoration: 'none' }}>Digital Assets</Link></li>
            <li><Link to="/solutions/hard-commodities" style={{ color: 'inherit', textDecoration: 'none' }}>Commodities</Link></li>
            <li><Link to="/solutions/private-equity" style={{ color: 'inherit', textDecoration: 'none' }}>Private Equity</Link></li>
            <li><Link to="/advisory" style={{ color: 'inherit', textDecoration: 'none' }}>Wealth Advisory</Link></li>
          </ul>
        </div>

        <div>
          <h4 style={{ color: 'var(--text-primary)', fontWeight: '700', marginBottom: '1.5rem', fontSize: '1rem' }}>Company</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <li><Link to="/about" style={{ color: 'inherit', textDecoration: 'none' }}>About Us</Link></li>
            <li><Link to="/insights" style={{ color: 'inherit', textDecoration: 'none' }}>Insights & News</Link></li>
            <li><Link to="/contact" style={{ color: 'inherit', textDecoration: 'none' }}>Contact Us</Link></li>
            <li><Link to="/careers" style={{ color: 'inherit', textDecoration: 'none' }}>Careers</Link></li>
          </ul>
        </div>

        {/* Contact Column */}
        <div>
          <h4 style={{ color: 'var(--text-primary)', fontWeight: '700', marginBottom: '1.5rem', fontSize: '1rem' }}>Contact</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
              <MapPin size={16} style={{ marginTop: '0.2rem', color: 'var(--accent-primary)' }} />
              <span>100 Wall Street, Suite 500<br/>New York, NY 10005</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Phone size={16} style={{ color: 'var(--accent-primary)' }} />
              <span>+1 (800) 555-0198</span>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Mail size={16} color="#fcd535" style={{ flexShrink: 0 }} />
              <a href="mailto:support@quantiscap.com" style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.2s' }} onMouseOver={(e)=>e.target.style.color='var(--accent-primary)'} onMouseOut={(e)=>e.target.style.color='inherit'}>support@quantiscap.com</a>
            </li>
          </ul>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', borderTop: '1px solid var(--border-color)', paddingTop: '2rem' }}>
        <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: '1.5rem', opacity: 0.8, textAlign: 'justify' }}>
          <strong>Risk Warning:</strong> Trading Foreign Exchange (Forex), Commodities, and Digital Assets on margin carries a high level of risk and may not be suitable for all investors. The high degree of leverage can work against you as well as for you. Before deciding to trade, you should carefully consider your investment objectives, level of experience, and risk appetite. The possibility exists that you could sustain a loss of some or all of your initial investment and therefore you should not invest money that you cannot afford to lose. You should be aware of all the risks associated with trading and seek advice from an independent financial advisor if you have any doubts. Quantis Capital does not provide financial or tax advice.
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <p style={{ margin: 0 }}>&copy; {new Date().getFullYear()} Quantis Capital. All rights reserved.</p>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <Link to="/terms#terms" style={{ color: 'inherit', textDecoration: 'none' }}>Terms of Service</Link>
            <Link to="/terms#privacy" style={{ color: 'inherit', textDecoration: 'none' }}>Privacy Policy</Link>
            <Link to="/terms#risk" style={{ color: 'inherit', textDecoration: 'none' }}>Risk Disclosure</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
